import "./03_component.css"

import Ps from "../../../../assets/Images/temp/photoshop.png"

export default function Component03() {
    return (
        <div className="Softwares-Marquee-Main"> 
            <div className="Softwares-Marquee-Division">
                <div className="Softwares-Marquee-Cards">
                    <p>Photoshop</p>
                </div>
                <div className="Softwares-Marquee-Cards">
                    <div className="Softwares-Marquee-Cards-Dot"></div>
                </div>
                <div className="Softwares-Marquee-Cards">
                    <p>Illustrator</p>
                </div>
                <div className="Softwares-Marquee-Cards">
                    <div className="Softwares-Marquee-Cards-Dot"></div>
                </div>
                <div className="Softwares-Marquee-Cards">
                    <p>InDesign</p>
                </div>
                <div className="Softwares-Marquee-Cards">
                    <div className="Softwares-Marquee-Cards-Dot"></div>
                </div>
                <div className="Softwares-Marquee-Cards">
                    <p>Figma</p>
                </div>
                <div className="Softwares-Marquee-Cards">
                    <div className="Softwares-Marquee-Cards-Dot"></div>
                </div>
                <div className="Softwares-Marquee-Cards">
                    <p>Premiere Pro</p>
                </div>
                <div className="Softwares-Marquee-Cards">
                    <div className="Softwares-Marquee-Cards-Dot"></div>
                </div>
                <div className="Softwares-Marquee-Cards">
                    <p>After Effects</p>
                </div>
                <div className="Softwares-Marquee-Cards">
                    <div className="Softwares-Marquee-Cards-Dot"></div>
                </div>
            </div>
            <div className="Softwares-Marquee-Division" aria-hidden="true">
                <div className="Softwares-Marquee-Cards">
                    <p>Photoshop</p>
                </div>
                <div className="Softwares-Marquee-Cards">
                    <div className="Softwares-Marquee-Cards-Dot"></div>
                </div>
                <div className="Softwares-Marquee-Cards">
                    <p>Illustrator</p>
                </div>
                <div className="Softwares-Marquee-Cards">
                    <div className="Softwares-Marquee-Cards-Dot"></div>
                </div>
                <div className="Softwares-Marquee-Cards">
                    <p>InDesign</p>
                </div>
                <div className="Softwares-Marquee-Cards">
                    <div className="Softwares-Marquee-Cards-Dot"></div>
                </div>
                <div className="Softwares-Marquee-Cards">
                    <p>Figma</p>
                </div>
                <div className="Softwares-Marquee-Cards">
                    <div className="Softwares-Marquee-Cards-Dot"></div>
                </div>
                <div className="Softwares-Marquee-Cards">
                    <p>Premiere Pro</p>
                </div>
                <div className="Softwares-Marquee-Cards">
                    <div className="Softwares-Marquee-Cards-Dot"></div>
                </div>
                <div className="Softwares-Marquee-Cards">
                    <p>After Effects</p>
                </div>
                <div className="Softwares-Marquee-Cards">
                    <div className="Softwares-Marquee-Cards-Dot"></div>
                </div>
            </div>
        </div>
    );
}